import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import {
  accentSecondary,
  linkHoveredAccent,
  breakpointSmall,
  linkAccent,
  lightMetaAccent,
  breakpointXL,
} from "../variables"
import { formatDate } from "../helpers"
import { HeadingThree } from "../elements"
import { slugify } from "../utils"

const PostNextData = ({ nextData }) => {
  const {
    featured_image,
    title,
    release_date,
    description,
    source,
  } = nextData.data
  const { tags } = nextData

  return (
    <NextContainer>
      <div className="container">
        <HeadingThree
          className="more-in-news"
          margin="0 0 26px 0"
          letterSpacing="0.1em"
        >
          MORE IN NEWS
        </HeadingThree>
        <div className="next-info">
          <div className="next-content">
            <Link to={`/news-and-updates/${slugify(title.text)}`}>
              <HeadingThree margin="0 0 10px 0" fontSize="26px">
                {title.text}
              </HeadingThree>
            </Link>
            <span className="next-meta">
              {formatDate(release_date)} | {source.text}{" "}
              <span className="tags">
                {tags.map((tag, i) => (
                  <Link key={i} to={`/tags/${tag}`}>
                    <span className="tag">{tag} </span>
                  </Link>
                ))}
              </span>
            </span>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: description.html }}
            ></div>
          </div>
          <img src={featured_image.url} alt={featured_image.alt} />
        </div>
      </div>
      <img
        className="illustration"
        src={"/related-post-illustration.svg"}
        alt=""
      />
    </NextContainer>
  )
}

export default PostNextData

const NextContainer = styled.div`
  padding: 61px 0 0 0;
  width: 100%;
  background: ${accentSecondary};
  position: relative;

  .illustration {
    display: none;
  }

  .next-meta {
    color: ${lightMetaAccent};
  }

  .tags {
    margin-left: 18px;
  }

  .tag {
    font-weight: 700;
    font-size: 13px;
    color: ${linkAccent};
  }

  .more-in-news,
  .next-content {
    padding: 0 20px;
  }

  .container {
    max-width: 1126px;
    margin: 0 auto;
    position: relative;
    z-index: 5;

    a:hover {
      color: ${linkHoveredAccent};
    }
  }

  .description {
    font-size: 15px;
    line-height: 24px;
  }

  .next-info {
    margin: 0 auto;

    img {
      position: relative;
      top: 5px;
      height: 300px;
      width: 100%;
      object-fit: cover;
    }
  }

  @media (min-width: ${breakpointSmall}) {
    padding: 61px 0 70px 0;

    .illustration {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 612.5px;
      z-index: 0;
      display: block;
    }

    .next-info {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-gap: 26px;

      img {
        height: auto;
        width: 458px;
        top: 0;
      }
    }
  }

  @media (min-width: ${breakpointXL}) {
    .illustration {
      width: 765.28px;
    }
  }
`

